<template>
  <div class="wrap">
    <div :class="textOver && !btnFold ? 'inner over' : 'inner'" ref="divRef">
      <span class="content" ref="spanRef">擅长：{{ showContent }}</span>
    </div>
    <img :src="bg_url" v-if="textOver" @click="showtext">
  </div>
</template>

<script>
import upper from "@/assets/appointment/xsj_s.png"
import lower from "@/assets/appointment/xsj_x.png"
export default {
  data() {
    return {
      textOver: false, //文本是否超出3行
      btnFold: false, //按钮默认显示展开
      bg_url: lower
    };
  },
  props: {
    showContent: {
      type: String,
      default: false
    }
  },
  created() {
    this.$nextTick(() => {
      // 判断文本是否超过3行
      if (this.$refs.divRef) {
        let descHeight = window.getComputedStyle(this.$refs.divRef).height.replace("px", "");
        // console.log("descHeight:" + descHeight);
        if (descHeight > 20) {
          this.textOver = true;
        } else {
          this.textOver = false;
        }
      }
    });
  },
  mounted() {},
  methods: {
    showtext(){
      this.btnFold = !this.btnFold;
      if(this.btnFold){
        this.bg_url = upper;
      } else {
        this.bg_url = lower;
      }
    }
  }
};
</script>

<style scoped lang="less">
.wrap {
  // padding-bottom: 30px;
  position: relative;
  >img{
    position: absolute;
    right: -20px;
    bottom: 0px;
    width: 18px;
  }
}
.content{
  width: 100%;
}
.over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.btn {
  font-size: 14px;
  color: #198bff;
  float: right;
  cursor: pointer;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/foldText/foldText.vue